import {useEffect, useState} from "react";
import {isNullOrUndefined} from "../../../services/Validator";
import {computePictureUrl} from "../../../controllers/flashScreens/questionsStepScreen/QuestionPictureController";
import Modal from "@mui/material/Modal";
import {kModalStyles} from "../../../constants/styles";
import SystemZoomedPictureError from "../../errors/SystemZoomedPictureError";
import SystemZoomedPictureLoader from "../../loaders/SystemZoomedPictureLoader";

export default function NeoFlashZoomedPictureDialog({open, handleClose, pictureUrl}) {
    // Used in LevelAExampleQuestion to display modal with
    // example zoomed picture

    // PROPERTIES
    const [hasError, setHasError] = useState(false)
    const [isLoading, setIsLoading] = useState(true)
    const [src, setSrc] = useState(null)

    // HOOKS
    useEffect(() => {
        if (!isNullOrUndefined(pictureUrl)) {
            // Switch loader on and clear potential error
            setSrc(null)
            setIsLoading(true)
            setHasError(false)
            // Prepare
            const url = computePictureUrl(pictureUrl)
            // Execute
            fetch(url).then((res) => {
                res.blob().then((res) => {
                    setSrc(URL.createObjectURL(res))
                }).catch((err) => {
                    console.log(err)
                    setHasError(true)
                })
            }).catch((err) => {
                console.log(err)
                setHasError(true)
            }).finally(() => {
                setIsLoading(false)
            })
        }
    }, [pictureUrl])

    // BUILD
    return(
        <Modal open={open}
               onClose={handleClose}>
            <div className={kModalStyles.dialogZoomedPictureStyle}>
                {hasError || isNullOrUndefined(pictureUrl)
                    ? <SystemZoomedPictureError />
                    : isLoading
                        ? <SystemZoomedPictureLoader />
                        : <div className="bg-white w-full flex justify-center items-center
                                            animate-appear relative cursor-pointer overflow-hidden rounded-[8px]">
                            <img src={src}
                                 alt="Illustration"
                                 className="object-contain max-h-[50vh] max-w-[50vw]"
                                 onError={() => setHasError(true)}
                                 onLoad={() => setHasError(false)} />
                        </div>}
            </div>
        </Modal>
    )
}